module.exports = __webpack_public_path__ + "img/kimson-doan-AZMmUy2qL6A-unsplash.188b2682.jpg";